import _ from 'lodash';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { Emitter, type Event } from '@patsnap/tahiti-core/common/event';
import type { CommentDialogState, QuickComment, BoxPosition } from '../type/comment-dialog.type';

export const CommentDialogService = Symbol('CommentDialogService');

export interface CommentDialogService {
    onStateChange: Event<CommentDialogState>;
    state: CommentDialogState;
    setIsShowingCommentBox(value: boolean): void;
    setIsShowingAddCommentBox(value: boolean | { display: boolean; position?: BoxPosition }): void;
    setIsShowingEditQuickComment(value: boolean): void;
    updateQuickComment(value: QuickComment): void;
}

@injectable()
export class CommentDialogServiceImpl implements CommentDialogService {
    private _onStateChangeEmitter = new Emitter<CommentDialogState>();
    readonly onStateChange = this._onStateChangeEmitter.event;

    private _state: CommentDialogState = {
        isShowingCommentBox: false,
        isShowingAddCommentBox: false,
        isShowingEditQuickComment: false,
        addCommentBoxPosition: {},
        quickComment: {
            comment_texts: [],
            predefined_comment_id: '',
        },
    };

    public get state() {
        return _.cloneDeep(this._state);
    }

    private _updateState(state: Partial<CommentDialogState>) {
        this._state = {
            ...this._state,
            ...state,
        };
        this._onStateChangeEmitter.fire(this.state);
    }

    public setIsShowingCommentBox(value: boolean) {
        this._updateState({
            isShowingCommentBox: value,
        });
    }

    public setIsShowingAddCommentBox(value: boolean | { display: boolean; position?: BoxPosition }) {
        if (typeof value === 'boolean') {
            this._updateState({
                isShowingAddCommentBox: value,
                addCommentBoxPosition: {},
            });
        } else {
            this._updateState({
                isShowingAddCommentBox: value.display,
                addCommentBoxPosition: value.position || {},
            });
        }
    }

    public setIsShowingEditQuickComment(value: boolean) {
        this._updateState({
            isShowingEditQuickComment: value,
        });
    }

    public updateQuickComment(value: QuickComment) {
        this._updateState({
            quickComment: value,
        });
    }
}
